(() => {
    if (window.__backInStockInitialized) return;
    window.__backInStockInitialized = true;

    class BackInStock {
        constructor(modal) {
            this.modal = modal;
            this.form = modal.querySelector('form');
            this.submitButton = this.form.querySelector('[type="submit"]');
            this.submitLabel = this.submitButton.querySelector('span');
            this.error = modal.querySelector('.error_message');
            this.success = modal.querySelector('.success_message');
            this.form.addEventListener('submit', (event) => {
                if (!this.variantId) return;
                event.stopImmediatePropagation();
                this.submit(event);
            }, true);
            modal.addEventListener('click', (event) => {
                if (event.target === modal || event.target.closest('.klaviyo_close_modal')) {
                    event.preventDefault();
                    this.close();
                }
            });
            modal.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    this.close();
                }
            });
        }

        close() {
            this.resetRequest();
            this.modal.classList.remove('active');
            this.modal.style.display = 'none';
            if (typeof removeTrapFocus === 'function') removeTrapFocus(this.trigger);
            else if (this.trigger?.isConnected) this.trigger.focus();
        }

        resetRequest() {
            this.request?.abort();
            this.request = null;
            this.submitButton.disabled = false;
            this.submitLabel.textContent = 'Notify Me When Available';
            this.form.removeAttribute('aria-busy');
        }

        open(trigger) {
            this.resetRequest();
            this.trigger = trigger;
            this.variantId = trigger.dataset.backInStockVariantId;
            this.modal.querySelector('.modal-title').textContent = trigger.dataset.backInStockTitle;
            this.form.reset();
            this.form.hidden = false;
            this.error.hidden = true;
            this.success.hidden = true;
            this.modal.classList.remove('klaviyo_modal--success');
            this.success.innerHTML = '<h3>Thanks for Signing Up!</h3><p>Keep an eye out for a back-in-stock message.</p>';
            this.modal.classList.add('active');
            this.modal.style.display = 'flex';
            if (typeof trapFocus === 'function') trapFocus(this.modal, this.form.elements.email);
            else this.form.elements.email.focus();
        }

        async submit(event) {
            event.preventDefault();
            if (this.request || !this.form.reportValidity()) return;
            this.error.hidden = true;
            this.success.hidden = true;
            if (!/^\d+$/.test(this.variantId || '') || !this.modal.dataset.companyId) {
                console.error('Back in stock subscription: missing variant or company ID.');
                this.error.textContent = 'This item’s waitlist is unavailable. Please refresh the page and try again.';
                this.error.hidden = false;
                return;
            }

            const request = new AbortController();
            this.request = request;
            this.submitButton.disabled = true;
            this.submitLabel.textContent = 'Submitting…';
            this.form.setAttribute('aria-busy', 'true');
            const timeout = setTimeout(() => request.abort(), 15000);

            try {
                const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.modal.dataset.companyId), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        revision: '2026-07-15'
                    },
                    signal: request.signal,
                    body: JSON.stringify({
                        data: {
                            type: 'back-in-stock-subscription',
                            attributes: {
                                channels: ['EMAIL'],
                                profile: {
                                    data: {
                                        type: 'profile',
                                        attributes: { email: this.form.elements.email.value.trim() }
                                    }
                                }
                            },
                            relationships: {
                                variant: {
                                    data: {
                                        type: 'catalog-variant',
                                        id: '$shopify:::$default:::' + this.variantId
                                    }
                                }
                            }
                        }
                    })
                });
                if (!response.ok) throw new Error('Klaviyo returned HTTP ' + response.status);
                // Closing/reopening the dialog must not apply an old request to another item.
                if (this.request !== request) return;
                this.form.hidden = true;
                this.modal.classList.add('klaviyo_modal--success');
                this.success.hidden = false;
                this.modal.querySelector('.klaviyo_close_modal').focus();
            } catch (error) {
                if (this.request !== request) return;
                console.error('Back in stock subscription failed:', error);
                this.error.textContent = 'We couldn’t save your request. Please try again.';
                this.error.hidden = false;
            } finally {
                clearTimeout(timeout);
                if (this.request === request) this.resetRequest();
            }
        }
    }

    let controller;
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-back-in-stock-variant-id]');
        if (!trigger) return;
        const modal = document.getElementById('k_id_modal');
        if (!modal) return;
        event.preventDefault();
        if (!controller || controller.modal !== modal) controller = new BackInStock(modal);
        controller.open(trigger);
    });
})();
